module.exports = __webpack_public_path__ + "r-v3/img/ico_attendance_white.34135485.svg";